<template>
  <div>
    <b-table
      :items="services"
      :fields="fields"
      :busy="loading"
      sort-by="descriptionDe"
      sort-direction="asc"
      show-empty
    >
      <template #table-busy>
        <div class="text-center my-3">
          <b-spinner />
        </div>
      </template>
      <template #cell(pricePurchasing)="{ value }">
        {{ value | currency }}
      </template>
      <template #cell(myPrice)="{ item }">
        <span v-if="item.accountService">
          {{ item.accountService.pricePurchasing | currency }}
        </span>
        <span v-else class="text-muted">—</span>
        <b-badge
          v-if="
            item.accountService &&
            item.accountService.status === 'pending_increase'
          "
          variant="warning"
          class="ml-1"
        >
          {{ $t('partner-prices.status-pending') }}
        </b-badge>
        <b-badge
          v-if="
            item.accountService && item.accountService.status === 'declined'
          "
          variant="danger"
          class="ml-1"
        >
          {{ $t('partner-prices.status-declined') }}
        </b-badge>
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    partner: { type: Object, required: true },
  },
  data() {
    return {
      services: [],
      loading: false,
    };
  },
  computed: {
    fields() {
      return [
        {
          key: 'descriptionDe',
          label: this.$t('partner-prices.service'),
          sortable: true,
        },
        {
          key: 'serviceType',
          label: this.$t('partner-prices.type'),
          sortable: true,
        },
        { key: 'unitMeasure', label: this.$t('partner-prices.unit') },
        {
          key: 'pricePurchasing',
          label: this.$t('partner-prices.gid-price'),
          class: 'text-right',
        },
        {
          key: 'myPrice',
          label: this.$t('partner-prices.partner-price'),
          class: 'text-right',
        },
      ];
    },
  },
  async created() {
    await this.load();
  },
  watch: {
    'partner.account.id': {
      immediate: false,
      handler() {
        this.load();
      },
    },
  },
  methods: {
    async load() {
      const partnerId = this.partner?.account?.id;
      if (!partnerId) return;
      this.loading = true;
      try {
        const { data } = await axios.get('/data-api/account-service/matching', {
          params: { partnerId },
        });
        this.services = data.map((s) => ({
          ...s,
          accountService: s.accountServices?.[0] ?? null,
        }));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
